
$(function () {
    
    // initialize wizard
    var form = $("#wizardform");
    $("#wizard").steps({
        headerTag: "h3",
        bodyTag: "section",
        transitionEffect: "slideLeft",
        stepsOrientation: "horizontal", //vertical - use bd-wizard-side as the bd-wizard.css file
        titleTemplate: '<span class="number">#title#</span>',
        onStepChanging: function (event, currentIndex, newIndex)
        {
            if(currentIndex > 1){
                // saveDraft('silent'); //silent save draft 
            }

            if (newIndex > currentIndex) {
                form.validate().settings.ignore = ":disabled,:hidden:not(.current .chosen-select)";
                return form.valid();
            } else {
                return true;
            }
        },
        onFinishing: function (event, currentIndex)
        {
            form.validate().settings.ignore = ":disabled";
            return form.valid();
        },
        onFinished: function (event, currentIndex)
        {
            // alert('Sumited');
            form.submit();
        },
    });

    // load recaptcha at end of wizard
    /* $(document).on('click', '[href="#next"], li.last', function() {
        if ($('li.last').hasClass('current')) {
            $.getScript( "https://www.google.com/recaptcha/api.js" )
            .done(function( script, textStatus ) {
                $('#recaptcha').addClass('captcha');
                // console.log( textStatus );
            })
            .fail(function( jqxhr, settings, exception ) {
                alert( "Recaptcha did not load. Please try refreshing your page and submitting again." );
            });

            if ($('#recaptcha').hasClass('captcha')) {
                setTimeout(function(){ 
                    grecaptcha.reset();
                }, 100);
                // console.log('reset')
            }
        }
    }); */

    // effective date datepicker
    // $('#effective_date').datepicker({
    //     format: "yyyy-mm-dd",
    //     endDate: "now()",
    //     startView: 1,
    //     autoclose: true
    // });

});